import Swiper from "swiper"
import {
  Autoplay,
  Navigation,
  Pagination,
  Thumbs,
  Scrollbar,
  Mousewheel,
  Virtual,
  EffectFade, Manipulation,
} from "swiper/modules"
import { getSizedImageUrl } from '@shopify/theme-images';
import { sendEvent } from '../../scripts/global/utils/sendEvent';

export default (
  params = { slidesPerView: 1 },
  destroyOnResize = false,
  destroyForMobile = false
) => ({
  swiper: null,
  initialized: false,
  productContainer: null,
  video: null,
  artistTitle: null,
  artistUrl: null,
  init() {
    this.initSlider()
    this.productContainer = document.getElementById("main-product")
    if (destroyOnResize) {
      this.destroyOnresize()
      window.addEventListener("resize", () => this.destroyOnresize())
    }

    if (destroyForMobile) {
      this.destroyForMobile()
      window.addEventListener("resize", () => this.destroyForMobile())
    }
  },
  initSlider() {
    if (!this.$el || !this.$el.classList) return;

    if (this.$el.classList.contains("swiper")) {
      this.swiper = new Swiper(this.$el, {
        modules: [
          Navigation,
          Pagination,
          Thumbs,
          Autoplay,
          Scrollbar,
          Mousewheel,
          Virtual,
          EffectFade,
          Manipulation
        ],
        ...params,
        on: {
          click: (event) => {

            if (event.clickedSlide.classList.contains("framed-image__slide--slide-builder")){
              return
             }
 
            let clickedImage = event.clickedSlide.querySelector(".zoomed-image")
        
          
            if (clickedImage){
              var src = clickedImage.getAttribute("data-image-source")
            }

            if (src){
              var imageSource = getSizedImageUrl(src, "master")
            }

            const videoContent = event.clickedSlide.querySelector("video source")
            if (videoContent) {
              var video = event.clickedSlide
                .querySelector("video source")
                .getAttribute("src")
            }

            const source = video ? video : imageSource
            const isPrivateCollectionProduct = this.$el.getAttribute("data-swthz")
            const isVideo = videoContent ? true : false

            if (this.zoomImage){
              this.zoomImage(source, event.realIndex, videoContent, event.clickedSlide, isVideo)
            }
          },
          slideChange: (event)=> {
            if (event.slides[event.activeIndex] && event.slides[event.activeIndex].getAttribute("data-artist-title")){
              this.artistTitle = event.slides[event.activeIndex].getAttribute("data-artist-title")
              this.artistUrl = event.slides[event.activeIndex].getAttribute("data-artist-url")
            }
          },
          realIndexChange: (event) => {
            const { activeIndex, previousIndex, realIndex } = event
            sendEvent(`PDP - Gallery ${ activeIndex > previousIndex ? 'Advance' : 'Reverse' }`, { event_detail: realIndex + 1 })
          },
        },
      })
    }
    this.initialized = true
  },
  slideToIndex(index) {
    this.swiper.slideToLoop(index, 10)
  },
  destroyOnresize() {
    if (window.innerWidth > 990 && this.swiper) {
      this.swiper.destroy()
    } else {
      this.initSlider()
    }
  },
  destroyForMobile() {
    if (window.innerWidth < 990) {
      if (this.swiper) {
        this.swiper.destroy(true, true)
        this.swiper = null
      }
    } else {
      if (!this.swiper) {
        this.initSlider()
      }
    }
  },
})
